import { render } from "./disabledOrder.vue?vue&type=template&id=462b27b4"
import script from "./disabledOrder.vue?vue&type=script&lang=js"
export * from "./disabledOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__